/**
 * SSO handoff para o app web Laravel (/sgp).
 *
 * Abre uma página do /sgp já autenticada, aproveitando a sessão do usuário no
 * sgp-web (token Passport). Emite um token de uso único no clique (não ao abrir
 * a página) via `POST /api/sgp/handoff`, e navega para a URL retornada.
 *
 * Uso: this.abreLaravelAutenticado('/sgp/propostas/123/relatorio')
 */
export const laravelHandoff = {
  methods: {
    abreLaravelAutenticado (path) {
      // Abre a aba de forma síncrona (dentro do gesto de clique) para não ser bloqueada por pop-up blocker.
      let win = window.open('', '_blank')

      axiosLaravel.post('sgp/handoff', { target: path }).then((response) => {
        if (win) {
          win.location = response.data.url
        } else {
          window.location = response.data.url
        }
      })
        .catch((error) => {
          // Fallback: abre o destino direto (cairá no login do /sgp se necessário).
          let base = this.$store.state.laravelurl || ''
          if (win) {
            win.location = base + path
          }
          this.$root.trataErro(error)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/laravelHandoff.js